module.exports = __webpack_public_path__ + "static/img/snapshotFlow.aaa7921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/snapshotFlow.png
// module id = 143
// module chunks = 1